<template>
  <Page class="detailView">
    <div class="pageContent-title">员工信息</div>
    <div class="detailView-with-actions mt-5">
      <a-form class="flex-form form-label-6" :form="form" :colon="false" labelAlign="left">
        <div class="form-base-width">
          <a-form-item label="员工姓名">
            <a-input
              v-decorator="[
                'nickname',
                {
                  rules: [
                    { required: true, message: '请输入员工姓名' },
                    {
                      min: 2,
                      message: '最小长度2',
                    },
                    {
                      max: 5,
                      message: '最大长度5',
                    },
                  ],
                },
              ]"
              placeholder="请输入员工姓名"
            ></a-input>
          </a-form-item>
          <a-form-item label="手机号码">
            <a-input
              v-decorator="[
                'phoneNumber',
                {
                  rules: [
                    { required: true, message: '请输入手机号码' },
                    { pattern: Reg.isMobile, message: '请输入正确的手机号' },
                  ],
                },
              ]"
              placeholder="请输入手机号码"
            ></a-input>
          </a-form-item>
          <a-form-item label="密码">
            <!-- [^\s]* -->
            <a-input
              v-decorator="[
                'password',
                {
                  rules: [
                    { required: type === 'ADD', message: '请输入密码' },
                    {
                      pattern: Reg.isPwd,
                      message: '密码6-20位,不能包含空字符',
                    },
                  ],
                },
              ]"
              placeholder="设置密码"
            ></a-input>
          </a-form-item>
          <a-form-item label="确认密码">
            <a-input
              v-decorator="[
                'confirmPassword',
                {
                  rules: [{ required: type === 'ADD', message: '请输入确认密码' }, { validator: validateEqual }],
                },
              ]"
              placeholder="请输入确认密码"
            ></a-input>
          </a-form-item>
        </div>
        <a-form-item label="账户角色">
          <a-radio-group
            v-decorator="[
              'roleId',
              {
                rules: [{ required: true, message: '请选择账户角色' }],
              },
            ]"
          >
            <a-radio :value="item.roleId" v-for="(item, index) in roleList" :key="index">
              {{ item.name }}
            </a-radio>
          </a-radio-group>
        </a-form-item>

      </a-form>
    </div>

    <div class="detailView-actions">
      <a-button class="app-btn condition-btns" type="primary" @click="doSave">保存</a-button>
    </div>
  </Page>
</template>
<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload.vue'
import Reg from '@/utils/reg'
export default {
  components: {
    Page,
    PictureCardUpload,
  },
  mixins: [toolMixin, queryViewMixin],
  data() {
    return {
      searchValue: '',
      showUpdateWechat: false,
      isBindGzh: 2,
      form: this.$form.createForm(this),
      roleList: [],
      Reg,
    }
  },
  async mounted() {
    await this.loadRoleList()
    this.initUserForm()
  },
  computed: {
    type() {
      return this.$route.query.userId ? 'EDIT' : 'ADD'
    },
  },
  methods: {
    handleSearch(inputValue, option) {
      const label = option.componentOptions.propsData.label
      return label.toLowerCase().includes(inputValue.toLowerCase())
    },
    doSave() {
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = { ...values, associationUserId: values.associationUserId || '' }
          console.log('params', params)
          try {

            await this.$axios.post('/user/admin/employee', {
              userId: this.$route.query.userId,
              ...params,
            })
            this.$message.success('操作成功!')
            this.$router.go(-1)
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    validateEqual(rule, value, callback) {
      const password = this.form.getFieldValue('password')
      if (value === password) {
        callback()
      } else {
        callback(new Error('两次输入密码不一致'))
      }
    },
    async loadRoleList() {
      const res = await this.$axios.get('/user/admin/permission/role', {
        params: {
          page: 1,
          limit: 10000,
        },
      })
      this.roleList = res.data.filter(v => v.roleId != 1)
    },
    async initUserForm() {
      if (this.type === 'EDIT') {
        const res = await this.$axios.get('/user/admin/employee/' + this.$route.query.userId)
        if (res.success) {
          this.safeSetFieldsValue$t(this.form, res.data)
        }
      }
    },
  },
}
</script>
<style scoped lang="less"></style>
